import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { GraphService } from '../../General/graph/graph.service';
import { TeacherGraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/teacher-graph-exercise.component';
import { AbstractNode } from 'graph-interactive/dist/lib/abstract/aNode';
import { AbstractEdge } from 'graph-interactive/dist/lib/abstract/aEdge';
import { GraphAlgorithm, GraphServiceJson, GraphRandom } from 'graph-interactive';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';


@Component({
  selector: 'app-t-find-hamilton',
  templateUrl: './t-find-hamilton.component.html',
  styleUrls: ['./t-find-hamilton.component.css']
})
export class TFindHamiltonComponent extends TeacherGraphExerciseComponent {
  private readonly canvasID: string = 'graph-canvas';
  private readonly selectPathID: string = 'selectPath';
  private readonly computeID: string = 'computeButton';
  private hamiltonPath: [AbstractNode[], AbstractEdge[]];

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, graphService: GraphService) {
    super(topicsService, activatedRoute);
    this.type = 'findHamilton';
    this.title = this.get('findHamilton');
    this.description = this.get('descriptionFindHamilton');
  }

  generate(){
    GraphRandom.generateGraph(this.graph);
}

  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    const graph: GraphUU = new GraphUU(canvas);

    const computeButton = <HTMLButtonElement>document.getElementById(this.computeID);
    computeButton.addEventListener('click', this.computeSolution, false);
    return graph;
  }

  computeSolution = () => {
    this.hamiltonPath = GraphAlgorithm.hamiltonPath(this.graph.getGraph());
    if(this.hamiltonPath == null){
      console.log("No hamilton path");
      return;
    }
    this.showPath(this.hamiltonPath);
  }

  showPath = (path: [AbstractNode[], AbstractEdge[]]) => {
    this.graph.highLightPath(path[0], path[1]);
  }

  generateDefinition(): any {

    const definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/hamiltonPath.png';
    definition.key = 'findHamilton%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }

    GraphServiceJson.exportGraph(this.graph, definition);

    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
  }

}


